<template>
  <div class="relative">
    <UserAvatar
      :firstName="firstName"
      :lastName="lastName"
      :verified="showVerified && isVerified"
      :verified-tooltip-position="verifiedTooltipPosition"
      :size="size"
      :imageUrl="userProfilePhotoUrl"
    />

    <transition name="fade" mode="out-in">
      <FavoriteIndicator v-if="showFavoriteIndicator" />
      <SkipIndicator v-else-if="showSkipIndicator" />
    </transition>
  </div>
</template>

<script>
import UserAvatar from "@/components/UserAvatar";
import FavoriteIndicator from "./FavoriteIndicator";
import SkipIndicator from "./SkipIndicator";
import { mapGetters } from "vuex";

export default {
  components: {
    UserAvatar,
    FavoriteIndicator,
    SkipIndicator,
  },

  props: {
    size: { type: Number, required: true },
    showFavInterested: { type: Boolean, required: false, default: true },
    showVerified: { type: Boolean, required: false, default: false },
    verifiedTooltipPosition: { type: String, required: false, default: "top" },
  },

  computed: {
    ...mapGetters("athleteProfile", [
      "firstName",
      "lastName",
      "userProfilePhotoUrl",
      "isFavorited",
      "isSkipped",
      "isApplicableCollegeCoach",
      "isVerified",
    ]),

    showFavoriteIndicator() {
      return (
        this.isApplicableCollegeCoach &&
        this.isFavorited &&
        this.showFavInterested
      );
    },

    showSkipIndicator() {
      return (
        this.isApplicableCollegeCoach &&
        this.isSkipped &&
        this.showFavInterested
      );
    }
  }
};
</script>